import baseAPI from "@/http";

const router = "api/seloDiagnosticoPerguntas";

export const seloDiagnosticoPerguntasAPI = {
  getPerguntas: (uf, parceiro) =>
    baseAPI.get(
      `${router}/obter-diagnostico-perguntas?uf=${uf}&parceiros=${parceiro}`
    ),
  getSituacaoDiagnostico: (municipioId, uf, parceiro) =>
    baseAPI.get(
      `${router}/obter-situacao-diagnostico/${municipioId}?uf=${uf}&parceiro=${parceiro}`
    ),
};
